import { PhotoshopController } from "../../../../photoshopController.js";

export class ParametersWidget {
    _parent: HTMLElement;
    photoshopController: PhotoshopController;
    _active: null;
    _visible: boolean;
    widgetDiv: HTMLElement | null;
    operation: any;

    constructor(parent: HTMLElement, controller: PhotoshopController) {
        this._parent = parent;
        this.photoshopController = controller;
        this._active = null;
        this._visible = true;
    }

    get active() {
        return this._active;
    }

    set active(value) {
        this._active = value;
    }

    get visible() {
        return this._visible;
    }

    set visible(value) {
        this._visible = value;
    }

    get parent() {
        return this._parent;
    }

    initEvent() {
        const closeBtn = document.getElementById("reglages-close");
        if (closeBtn) {
            closeBtn.addEventListener("click", function () {
                this.reglages_closeOnClick();
            }.bind(this));
        }

        const reglagesEye = document.getElementById("reglages-eye");
        if (reglagesEye) {
            reglagesEye.addEventListener("click", function () {
                this.reglages_eyeOnClick();
            }.bind(this));
        }

        const reglagesUndo = document.getElementById("reglages-undo");
        if (reglagesUndo) {
            reglagesUndo.addEventListener("click", function () {
                this.reglages_undoOnClick();
            }.bind(this));
        }

        const reglagesCalque = document.getElementById("reglages-calque");
        if (reglagesCalque) {
            reglagesCalque.addEventListener("click", function () {
                this.reglages_calqueOnClick();
            }.bind(this));
        }
    }

    static header() {
        return `
        <div id="parameters">
        <div id="reglages-close" style="position: absolute; top: 10px; right: 10px">
            <i class="far fa-times-circle"></i>
        </div>
        `;
    }

    static footer() {
        return `
        <div class="s12 row right" style="margin-top: 20px;">
            <i id="reglages-eye" class="col fas"></i>
            <i id="reglages-undo" class="col fas fa-undo-alt"></i>
        </div>
        <div id="reglages-edit" class="col s12 row" style="display: none;">
            <button id="reglages-calque" class="col s12 no-padding btn">Ajouter le calque</button>
        </div>
        </div>
        `;
    }

    destroy() {
        this.widgetDiv = document.getElementById("parameters");
        if (this.widgetDiv) {
            this.widgetDiv.remove();
        }
        this.operation.destroy();
        this.photoshopController.update();
    }

    reglages_closeOnClick() {
        this.photoshopController.setActiveOperation(null);
    }

    reglages_eyeOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.active = !this.photoshopController.PSEngine.activeOperation.activated;
        this.updateClass();
        this.photoshopController.photoshopWidget.dataPanelWidget.layersWidget.updateClass();
        this.photoshopController.update();

    }

    reglages_undoOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.PSEngine.activeOperation.reset();
        this.photoshopController.update();
    }

    reglages_calqueOnClick() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        this.photoshopController.addOperation();
        this.photoshopController.setActiveOperation(this.photoshopController.PSEngine.activeOperation.program, this.photoshopController.PSEngine.activeOperation);
    }

    updateIf() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.type === 'FILTER') {
            const reglagesElem = document.getElementById("reglages");
            if (reglagesElem) {
                reglagesElem.style.display = "";
            }
        } else {
            const reglagesElem = document.getElementById("reglages");
            if (reglagesElem) {
                reglagesElem.style.display = "none";
            }
        }
        if (!this.photoshopController.isEditing()) {
            const reglagesEditElem = document.getElementById("reglages-edit");
            if (reglagesEditElem) {
                reglagesEditElem.style.display = "";
            }
        } else {
            const reglagesEditElem = document.getElementById("reglages-edit");
            if (reglagesEditElem) {
                reglagesEditElem.style.display = "none";
            }
        }
    }

    updateClass() {
        if (!this.photoshopController.PSEngine) {
            return;
        }
        if (this.photoshopController.PSEngine.activeOperation && this.photoshopController.PSEngine.activeOperation.activated) {
            const reglagesEyeElem = document.getElementById("reglages-eye");
            if (reglagesEyeElem) {
                reglagesEyeElem.classList.add('fa-eye');
            }
        } else {
            const reglagesEyeElem = document.getElementById("reglages-eye");
            if (reglagesEyeElem) {
                reglagesEyeElem.classList.remove('fa-eye');
            }
        }
        if (this.photoshopController.PSEngine.activeOperation && !this.photoshopController.PSEngine.activeOperation.activated) {
            const reglagesEyeSlashElem = document.getElementById("reglages-eye");
            if (reglagesEyeSlashElem) {
                reglagesEyeSlashElem.classList.add('fa-eye-slash');
            }
        } else {
            const reglagesEyeSlashElem = document.getElementById("reglages-eye");
            if (reglagesEyeSlashElem) {
                reglagesEyeSlashElem.classList.remove('fa-eye-slash');
            }
        }
    }
}
